import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import CampAthletesCreateEditForm from './Components/CampAthletesCreateEditForm';
import CampAthletesApi from './CampAthletesApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: CampAthletesCreateEditForm,
                getCreate: CampAthletesApi.create,
                defaults: {},
                successMessage: "Camp Athlete Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}